export default "__VITE_ASSET__Ck0abEP6__"